import AbstractComponent from './AbstractComponent';
import Canvas from './Canvas';
import frag from 'shaders/splash.frag';
import vert from 'shaders/splash.vert';

class Header extends AbstractComponent {
	constructor() {
		super(...arguments);
	}

	getUI() {
		const ui = super.getUI();
		ui.$background = document.querySelector('.footer__background');
		return ui;
	}

	initializeBeforeEvents() {
		const { $background: $element } = this.ui;

		if ($element) {
			this.canvas = new Canvas({
				$element,
				frag,
				vert
			});

			this.canvas.parameters.centerY = 1.15;
		}
	}
}

export default Header;
